module.exports = __webpack_public_path__ + "static/media/banner_shopee.08560118.svg";